export const accessibilityStatementContentHTML = `
      <p>Wir verpflichten uns, unsere Website für alle Benutzer zugänglich zu machen, unabhängig von ihren Fähigkeiten oder technologischen Einschränkungen. Unsere Barrierefreiheitserklärung beschreibt, wie wir dies erreichen und welche Maßnahmen wir ergreifen, um die Zugänglichkeit kontinuierlich zu verbessern.</p>
      <p>Diese Website wurde unter Berücksichtigung der WCAG 2.1 AA-Standards entwickelt und implementiert. Wir arbeiten kontinuierlich daran, die Zugänglichkeit zu verbessern und etwaige Barrieren zu beseitigen.</p>
      <p>Unsere Maßnahmen zur Barrierefreiheit umfassen:</p>
      <p>- Eine zugängliche Farbpalette mit ausreichenden Kontrastverhältnissen<br>
      - Tastaturnavigation für alle Funktionen<br>
      - Unterstützung für Screenreader und andere Hilfstechnologien<br>
      - Klare und konsistente Navigation<br>
      - Textliche Alternativen für nicht-textliche Inhalte<br>
      - Responsive Design für verschiedene Geräte und Bildschirmgrößen</p>
      <p>Wir überwachen regelmäßig die Barrierefreiheit unserer Website und führen Audits durch, um Verbesserungsmöglichkeiten zu identifizieren. Wir sind bestrebt, identifizierte Probleme so schnell wie möglich zu beheben.</p>
      <p>Sollten Sie auf Barrieren stoßen oder Schwierigkeiten bei der Nutzung unserer Website haben, zögern Sie nicht, uns zu kontaktieren. Ihre Rückmeldungen helfen uns, die Zugänglichkeit weiter zu verbessern.</p>
      <p>Wir führen regelmäßige Schulungen für unser Entwicklungsteam durch, um sicherzustellen, dass Barrierefreiheit von Anfang an in unseren Entwicklungsprozess integriert wird.</p>
      <p>Diese Erklärung wurde zuletzt am 23. April 2023 aktualisiert und wird regelmäßig überprüft, um sicherzustellen, dass sie unsere aktuellen Praktiken und Verpflichtungen widerspiegelt.</p>
    `;

export const privacyPolicyContentHTML = `
      <h3>Datenschutz‑Informationen für das <strong>accessibleAI‑Widget</strong></h3>
      <p><em>(Kurzfassung gemäß Art. 13 DSGVO – Stand: 28. Juni 2025)</em></p>
      <p>Diese Hinweise betreffen <strong>ausschließlich</strong> die Verarbeitung personenbezogener Daten, die durch das in diese Website eingebettete Widget der accessibleAI SmartCompliance GmbH erfolgt. Für alle anderen Vorgänge gilt die Datenschutzerklärung des jeweiligen Websitebetreibers.</p>
      
      <hr>
      
      <h4>1. Verantwortlicher</h4>
      <p>accessibleAI SmartCompliance GmbH<br>
      Altheimer Eck 5, 80331 München, Deutschland<br>
      E‑Mail: <a href="mailto:privacy@accessibleai.eu">privacy@accessibleai.eu</a></p>
      
      <hr>
      
      <h4>2. Zwecke, Datenkategorien und Rechtsgrundlagen</h4>
      <div style="overflow-x: auto; margin: 10px 0;">
        <table style="width: 100%; min-width: 480px; border-collapse: collapse; font-size: 12px;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 25%;">Zweck</th>
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 25%;">Daten</th>
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 50%;">Rechtsgrundlage</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;"><strong>Widget‑Bereitstellung</strong></td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">IP‑Adresse, Browser‑Header, Zeitstempel</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;"><strong>Barrierefreiheits‑Analyse</strong> (nach Klick „Scannen")</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Nutzer‑URL, öffentlicher HTML‑Code</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahme)</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;"><strong>Fehler‑ & Nutzungsprotokolle</strong></td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Pseudonymisierte Session‑ID, Ereignis‑Logs</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Art. 6 Abs. 1 lit. f DSGVO (Sicherheit & Verbesserung)</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <blockquote style="background-color: #f9f9f9; border-left: 4px solid #007bff; padding: 10px; margin: 10px 0;">
        <strong>Keine Tracking‑ oder Marketing‑Cookies</strong>: Das Widget setzt lediglich einen technisch notwendigen „sessionStorage"-Key; es werden <strong>keine</strong> Analyse‑ oder Profiling‑Cookies platziert.
      </blockquote>
      
      <hr>
      
      <h4>3. Auftragsverarbeiter</h4>
      <div style="overflow-x: auto; margin: 10px 0;">
        <table style="width: 100%; min-width: 360px; border-collapse: collapse; font-size: 12px;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 40%;">Dienst</th>
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 15%;">Standort</th>
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 45%;">Zweck</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;"><strong>Supabase (AWS EU‑Frankfurt)</strong></td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">EU</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Hosting der Widget‑Datenbank</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;"><strong>Google Vertex AI (EU‑Region)</strong></td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">EU</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">KI‑Analyse des HTML‑Codes</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;"><strong>browserless.io (AWS EU‑Frankfurt)</strong></td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">EU</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Headless‑Browser zum Abruf der öffentlichen Seite</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <p>Mit allen Dienstleistern bestehen Verträge nach Art. 28 DSGVO (inkl. EU‑Standardvertragsklauseln, falls erforderlich).</p>
      
      <hr>
      
      <h4>4. Speicherdauer</h4>
      <div style="overflow-x: auto; margin: 10px 0;">
        <table style="width: 100%; min-width: 300px; border-collapse: collapse; font-size: 12px;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 40%;">Datensatz</th>
              <th style="border: 1px solid #ddd; padding: 6px; text-align: left; width: 60%;">Dauer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">IP‑Adresse & Logs</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">30 Tage</td>
            </tr>
            <tr>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Analyse‑Ergebnisse</td>
              <td style="border: 1px solid #ddd; padding: 6px; word-wrap: break-word;">Bis zur Änderung der analysierten Seite (grundsätzlich unbegrenzt)</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <hr>
      
      <h4>5. Betroffenenrechte</h4>
      <p>Sie haben die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit sowie Widerspruch (Art. 15‑21 DSGVO). Kontaktieren Sie uns unter <a href="mailto:privacy@accessibleai.eu">privacy@accessibleai.eu</a>.</p>
      
      <hr>
      
      <h4>6. Automatisierte Entscheidungen</h4>
      <p>Das Widget trifft <strong>keine</strong> Entscheidungen mit rechtlicher oder ähnlich erheblicher Wirkung gemäß Art. 22 DSGVO.</p>
      
      <hr>
      
      <h4>7. Kontakt der Aufsichtsbehörde</h4>
      <p>Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 27, 91522 Ansbach, Deutschland.</p>
    `;

export const privacyConsentOverlayContentHTML = `
      <div id="vae-privacy-consent-content">
        <h3>Einwilligungserklärung zum Datenschutz</h3>
        <p>Bitte lesen Sie die folgenden Informationen sorgfältig durch.</p>
        <div id="vae-privacy-consent-declaration-text">
          <p><em>[Hier wird der vollständige Text der Einwilligungserklärung dynamisch geladen oder ist fest einkodiert. Dieser Text beschreibt, welche Daten zu welchem Zweck verarbeitet werden und wie der Nutzer seine Zustimmung geben und widerrufen kann.]</em></p>
          <p><strong>Beispielhafte Inhalte:</strong></p>
          <ul>
            <li>Welche Daten werden erfasst (z.B. Seiten-URL, HTML-Struktur-Ausschnitte für Analyse, Nutzerinteraktionen mit dem Widget)?</li>
            <li>Zu welchem Zweck werden diese Daten verarbeitet (z.B. zur Bereitstellung von Barrierefreiheitsanpassungen, zur Analyse von Problemen, zur Verbesserung des Dienstes)?</li>
            <li>Wie und wo werden die Daten gespeichert? Wie lange?</li>
            <li>Werden Daten an Dritte weitergegeben?</li>
            <li>Wie kann die Einwilligung widerrufen werden?</li>
            <li>Verweis auf die vollständige Datenschutzerklärung.</li>
          </ul>
          <p>Durch die weitere Nutzung dieses Widgets oder durch Klicken auf "Akzeptieren" stimmen Sie der Verarbeitung Ihrer Daten gemäß dieser Erklärung zu.</p>
        </div>
        <div id="vae-privacy-consent-actions">
          <button id="vae-privacy-accept-button" class="vae-button">Akzeptieren</button>
          <button id="vae-privacy-decline-button" class="vae-button">Ablehnen</button>
        </div>
      </div>
    `;

export const privacyWithdrawConsentOverlayContentHTML = `
      <div id="vae-privacy-withdraw-content">
        <h3>Datenschutzeinstellungen verwalten</h3>
        <p>Sie haben der Verarbeitung Ihrer Daten gemäß unserer Datenschutzerklärung zugestimmt. Hier können Sie Ihre Einwilligung widerrufen.</p>
        <p>Wenn Sie Einwilligung widerrufen, wird das Widget möglicherweise nicht mehr voll funktionsfähig sein, da bestimmte Daten für dessen Betrieb erforderlich sind.</p>
        <div id="vae-privacy-withdraw-actions">
          <button id="vae-privacy-withdraw-button" class="vae-button">Einwilligung widerrufen</button>
          <button id="vae-privacy-keep-settings-button" class="vae-button">Einstellungen beibehalten</button>
        </div>
      </div>
    `; 